export enum GroupCompanyDataBy {
  Type = 'type',
  Folder = 'folder',
}
